import { Box, Grid, GridItem, Text } from '@chakra-ui/react';
import { FC } from 'react';

type HeaderElementProps = {
  text: string;
};

const HeaderElement: FC<HeaderElementProps> = ({ text }) => (
  <Text color="inherit" noOfLines={1}>
    {text}
  </Text>
);

export const ContractListHeader: FC = () => (
  <Box
    m={0}
    h="40px"
    w="100%"
    pl="16px" // list-item の padding-left に合わせる
    pr="16px" // スクロールバー分の余白
    borderBottom="2px"
    borderBottomColor="secondaryList.header.borderColor"
    bgColor="secondaryList.header.bgColor"
  >
    <Grid
      h="100%"
      templateColumns="2fr 3fr 7fr 2fr 3fr 3fr"
      gap={0}
      justifyItems="start"
      alignItems="center"
    >
      <GridItem pl="20px" minW="100%" maxW="100%">
        <HeaderElement text="契約 ID" />
      </GridItem>
      <GridItem pl="20px" minW="100%" maxW="100%">
        <HeaderElement text="メニュー ID" />
      </GridItem>
      <GridItem pl="20px" minW="100%" maxW="100%">
        <HeaderElement text="メニュー名" />
      </GridItem>
      <GridItem pl="20px" minW="100%" maxW="100%">
        <HeaderElement text="有効/無効" />
      </GridItem>
      <GridItem pl="20px" minW="100%" maxW="100%">
        <HeaderElement text="契約開始日" />
      </GridItem>
      <GridItem pl="20px" minW="100%" maxW="100%">
        <HeaderElement text="契約終了日" />
      </GridItem>
    </Grid>
  </Box>
);
